class WishlistDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.checkLoggedIn = this.checkLoggedIn.bind(this)
    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(document, 'checkIsInWishlist', this.checkIsInWishlist)

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      this.checkLoggedIn()
      this.checkIsInWishlist()

      this.externalEls.trigger?.elements.forEach((el) => {
        el.setAttribute('data-wishlist-active', '')
      })
    })
  }

  checkLoggedIn () {
    if (this.hasAttribute('data-is-customer')) return

    /* eslint-disable no-console */
    window._swat.disconnectShopperContext(
      (onSuccess) => console.log('User cleared'),
      this.wishlistError,
    )
    /* eslint-enable */
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-drawer-external-el="trigger"]',
    )
    if (!trigger || !window._swat) return

    const product = {
      epi: parseInt(trigger.dataset.variantId, 10),
      empi: parseInt(trigger.dataset.productId, 10),
      du: trigger.dataset.productUrl,
    }

    if (trigger.hasAttribute('data-wishlist-added')) {
      // Remove from wishlist
      const lid = trigger.dataset.wishlistId
      window._swat.deleteFromList(
        lid,
        product,
        this.checkIsInWishlist,
        this.wishlistError,
      )
    } else {
      // Add to default wishlist
      window._swat.fetchLists({
        callbackFn: (lists) => {
          if (lists.length > 0) {
            const defaultList = lists[0]
            this.addToWishlist(defaultList.lid, product)
          } else {
            // Create "My Wishlist" if no wishlist exists
            window._swat.createList(
              { lname: 'My Wishlist' },
              (newList) => this.addToWishlist(newList.lid, product),
              this.wishlistError,
            )
          }
        },
        errorFn: this.wishlistError,
      })
    }
  }

  addToWishlist (lid, product) {
    window._swat.addToList(
      lid,
      product,
      this.checkIsInWishlist,
      this.wishlistError,
    )
  }

  checkIsInWishlist () {
    window._swat.fetchLists({
      callbackFn: (lists) => {
        const productCount = lists.reduce(
          (accumulator, list) => accumulator + list.cnt,
          0,
        )

        this.externalEls?.count?.elements.forEach((countEl) => {
          countEl.setAttribute('aria-hidden', productCount === 0)
        })

        this.externalEls?.trigger?.elements.forEach((el) => {
          const matchedProduct = lists.find((list) =>
            list.listcontents.find(
              (product) => product.epi === parseInt(el.dataset.variantId, 10),
            ),
          )

          if (matchedProduct) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedProduct.lid)
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
          }

          el.setAttribute('data-wishlist-active', '')
        })
      },
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);
  }
}

if (!customElements.get('wishlist-drawer')) {
  customElements.define('wishlist-drawer', WishlistDrawer)
}
